import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import { nmosdDiagnosticCriteria } from 'neuro-schemas';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { newButton } from '../../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const {
  utils: { diagnosisCriteriaAreFullfilledWithAQP4, diagnosisCriteriaAreFullfilledWithoutAQP4 },
} = nmosdDiagnosticCriteria;

const formatCriteria = (d: INMOSDDiagnosticCriteria, fm: (id: string) => string): React.JSX.Element | string => {
  const withAQP4 = diagnosisCriteriaAreFullfilledWithAQP4(d);
  const withoutAQP4 = diagnosisCriteriaAreFullfilledWithoutAQP4(d);
  if (d.AQP4IgGResult === 'negative' && withoutAQP4 === 'yes')
    return (
      <div>
        {fm('general.yes')} {fm('diagnosis.nmosdDiagnosticCriteria.history.withoutAQP4')}
      </div>
    );
  if (d.AQP4IgGResult === 'positive' && withAQP4 === 'yes')
    return (
      <div>
        {fm('general.yes')} {fm('diagnosis.nmosdDiagnosticCriteria.history.withAQP4')}
      </div>
    );
  if ((d.AQP4IgGResult === 'negative' && withoutAQP4 === 'no') || (d.AQP4IgGResult === 'positive' && withAQP4 === 'no'))
    return <div>{fm('general.no')}</div>;
  return fm('general.unknown');
};

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'nmosdDiagnosticCriteria'>[] = [];
const NMOSDDiagnosticCriteriaHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'nmosdDiagnosticCriteria'>>): React.JSX.Element => {
  const nmosdCriteria = filterDocumentsByType(documents, ['nmosdDiagnosticCriteria']).sort(sortDocumentsDescending);

  return (
    <HistoryRow
      headerText={fm('diagnosis.nmosdDiagnosticCriteria.history.title')}
      rowButton={
        startEdit
          ? newButton('nmosdDiagnosticCriteria', startEdit({}, 'nmosdDiagnosticCriteria'), 'general.new', 15)
          : undefined
      }
    >
      <HistoryRowListing
        documents={nmosdCriteria}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={3}>{fm('diagnosis.nmosdDiagnosticCriteria.history.usedCriteria')}</Item>
            <Item xs={7}>{fm('diagnosis.nmosdDiagnosticCriteria.history.criteriasAreFullfilled')}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={3}>{fm('diagnosis.nmosdDiagnosticCriteria.history.wingerchuk')}</Item>
            <Item xs={4}>{formatCriteria(d, fm)}</Item>
            <Item xs={3}>
              {startEdit ? <HistoryRowControls document={d} startEdit={startEdit} view={view} /> : null}
            </Item>
          </>
        )}
      />
    </HistoryRow>
  );
};

export default NMOSDDiagnosticCriteriaHistory;
